import { ALLOWED_PAYEE_VERIFICATION_MESSAGE_STEP_TWO } from "../constants/payeeVericationConstants";
import {
    getConfirmationMessageContentKey, 
    getConfirmationScreenMessageTitleKey,
} from "../helpers/payeeVerificationHelper";
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');

//require('../../step.scss');
require("./transferStep2.scss");

// @ vendors
const React = require("react");
const { connect } = require("react-redux");
const PropTypes = require("prop-types");

// @ actions
const transferActions = require("actions/transferActions");
const signaturePatternActions = require("actions/signaturePattern");

// @helpers
const { buildNotDeductMessageNGO } = require("utilities/NGOHelper");
const { formatText, FormattedText, getLanguage, formatTextNamed } = require("core/i18n").i18n;
const { toCamelCase } = require("utilities/stringHelper");
const {
    formatAmountObject,
    getPlainAmountObject,
    formatAmount,
    formatCurrency
} = require("utilities/currencyHelper");
const constants = require("constants/index");
const { getTranslatedCountry } = require("constants/countries");
const dateHelper = require("utilities/dateHelper");
const {
    getParamsOTP,
    getSepaTypeTransfers,
    isSepa
} = require("utilities/transfersHelper");
const {
    buildCustomPeriodicityText
} = require("utilities/contactCenter/transfersHelper");
const { recordPath, PROC_STEP } = require("utilities/tagging");
const {
    contactCenterClassName
} = require("utilities/conditionals/conditionalClassname");

// @ components
const { OKLink } = require("commonsComponents/OKLink");
const { OKMessage, MESSAGE_TYPE_IMPORTANT } = require("commonsComponents/OKMessage");
const { FormattedIban } = require("commonsComponents/formattedIban");
const OKInformativeList = require("components/rebrand/OKInformativeList/OKInformativeList");
const OKInformativeListItem = require("components/rebrand/OKInformativeListItem/OKInformativeListItem");
const {
    OneLineSymbolAmount
} = require("commonsComponents/oneLineSymbolAmount");
const SignaturePattern = require("components/signaturePattern/signaturePattern")
    .SignaturePattern;
const { Accordion } = require("commonsComponents/accordion");
const { AccordionHeader } = require("commonsComponents/accordionHeader");
const { AccordionBody } = require("commonsComponents/accordionBody");
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_GREETING,
    CONFIRMATION_SCRIPT_AGREEMENT
} = require("components/contactCenter/confirmScript/confirmationScript");
const ContactCenterRender = require("components/conditionalRender/contactCenterRender");
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

//@constants
const language = getLanguage();
const {
    BENEFICIARY_TYPE_NEW,
    BENEFICIARY_TYPE_NGO,
    FIRST_STEP,
    HYPHEN,
    EURO_TEXT
} = require("constants/index");
const {
    COUNTRIES_CODES: { PT }
} = require("constants/countries");
const {
    MULTIPLE_OPERATIONS,
    ADD_SEPA_BENEFICIARY_ID,
    ADD_NO_SEPA_BENEFICIARY_ID,
    EDIT_SEPA_BENEFICIARY_ID,
    EDIT_NO_SEPA_BENEFICIARY_ID,
    messages: { CODIGO_MESSAGE_4, CODIGO_MESSAGE_5 }
} = require("constants/operationTypes");

// @ Contact Center
const {
    CC_PERIODICITY_CUSTOM,
    CC_TRANSFER_TYPE_PAYROLL
} = require("constants/contactCenter/transfers");

class TransferStep2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showOTP: false
        };

        this.setNode = this.setNode.bind(this);
        this.buildBeneficiaryBlock = this.buildBeneficiaryBlock.bind(this);
        this.buildPeriodicityText = this.buildPeriodicityText.bind(this);
    }

    componentDidMount() {
        const beneficiaryType = this.props.immTransferState.getIn([
            "steps",
            0,
            "beneficiary",
            "type"
        ]);

        if (
            this.props.immTransferState.getIn([
                "steps",
                0,
                "beneficiary",
                "notDeductibleNGOMessage"
            ])
        ) {
            this.props.setWithValidateButton(true);
        }

        if (beneficiaryType === BENEFICIARY_TYPE_NGO) {
            recordPath(
                window.location.pathname,
                "proc-transferencia-solidaria",
                PROC_STEP + "1"
            );
        }
    }

    setNode(ref) {
        this.nodeReference = ref;
    }

    shouldWarnAboutCosts() {
        const { immBeneficiary, immTransferState } = this.props;
        const currencyType = ["SEK", "RON"];
        const returnCode = immTransferState.getIn(["extra", "returnCode"]);
        const operationCode = immTransferState.getIn([
            "extra",
            "operationCode"
        ]);
        const sepaCurrencyCommission = currencyType.includes(
            immBeneficiary.get("currency")
        );

        return (
            returnCode === "PE" ||
            operationCode === "PE" ||
            sepaCurrencyCommission
        );
    }

    buildBeneficiaryBlock(immBeneficiary) {
        const { immBankEntity } = this.props;
        const iban = immBeneficiary.get("iban");
        const country = toCamelCase(
            getTranslatedCountry(immBeneficiary.get("country"))
        );

        const countrySubBlock = (
            <div
                className="transfer-step__country"
                key={`transferStep2-beneficiary-country`}
            >
                {country}
            </div>
        );
        let bankEntityBlock;
        let accountSubBlock;
        const bankName = immBankEntity.get("bankName") || HYPHEN;

        const bic = immBeneficiary.get("bic");
        const bicText = formatText("transferSummary-step1BeneficiaryBicShort");

        if (iban) {
            accountSubBlock = (
                <div key={`transferStep2-beneficiary-iban`}>
                    <FormattedText
                        value="transferSummary-step1BeneficiaryIban"
                        className="transfer-step__iban-label"
                    />
                    <FormattedIban
                        className="transfer-step__iban-data"
                        id="txt_TransferStep2_BeneficiaryIban"
                        iban={iban}
                    />
                </div>
            );

            if (Boolean(bankName)) {
                bankEntityBlock = (
                    <div
                        className="transfer-step__iban-data"
                        key={`transferStep2-beneficiary-iban-bankEntity`}
                    >
                        {`(${bankName})`}
                    </div>
                );
            }
        } else {
            accountSubBlock = (
                <div key={`transferStep2-beneficiary-accountNumber`}>
                    <FormattedText
                        value="transferSummary-step1BeneficiaryAccountNumber"
                        className="transfer-step__iban-label"
                    />
                    <span className="transfer-step__iban-data">
                        {immBeneficiary.get("accountNumber")}
                    </span>
                </div>
            );

            if (Boolean(bic)) {
                bankEntityBlock = (
                    <div
                        className="transfer-step__iban-data"
                        key={`transferStep2-beneficiary-bic-bankEntity`}
                    >
                        {`${bicText} ${bic}`}
                        <br />
                        {`(${bankName})`}
                    </div>
                );
            }
        }

        return [accountSubBlock, bankEntityBlock, countrySubBlock];
    }

    buildIncompleteInfoCommissionLine() {
        const { immTransferState } = this.props;
        const immIncompleteInfoCommission = immTransferState.getIn([
            "extra",
            "costs",
            "incompleteInfoCommission"
        ]);
        let incompleteInfoCommissionLine;

        if (!!immIncompleteInfoCommission) {
            const incompleteInfoCommission = getPlainAmountObject(
                immIncompleteInfoCommission
            );
            incompleteInfoCommissionLine = (
                <div className="transfer-step__costs-accordion-body-item">
                    <FormattedText value="transferSummary-step2IncompleteInfoCommission" />
                    <OneLineSymbolAmount
                        amountObject={incompleteInfoCommission}
                        amountObjectFormatted={formatAmountObject(
                            incompleteInfoCommission,
                            true
                        )}
                        className="pull-right"
                        language={language}
                    />
                </div>
            );
        }

        return incompleteInfoCommissionLine;
    }

    buildCostAdditionalInfo() {
        const { immTransferState, immBeneficiary } = this.props;
        const firstStep = immTransferState.getIn(["steps", 0]);
        const immCostDetails = immTransferState.getIn(["extra", "costs"]);
        const plainAmountTotalObject = getPlainAmountObject(
            immCostDetails.get("total")
        );
        const plainAmountNominalObject = getPlainAmountObject(
            immCostDetails.get("nominal")
        );
        const plainAmountCounterObject = getPlainAmountObject(
            immCostDetails.get("counterpart")
        );
        const plainAmountOwnerObject = getPlainAmountObject(
            immCostDetails.get("owner")
        );
        const plainAmountBeneficiaryObject = getPlainAmountObject(
            immCostDetails.get("beneficiary")
        );
        const plainAmountCommisionObject = getPlainAmountObject(
            immCostDetails.get("commisionFee")
        );
        const incompleteInfoCommissionLine = this.buildIncompleteInfoCommissionLine();
        let paymentType;

        switch (firstStep.get("costs")) {
            case constants.TRANSFER_COSTS_SENDER:
                paymentType = formatText(
                    "transferSummary-step2PaymentByIssuer"
                );
                break;
            case constants.TRANSFER_COSTS_SHARED:
                paymentType = formatText(
                    "transferSummary-step2PaymentByShared"
                );
                break;
            case constants.TRANSFER_COSTS_BENEFICIARY:
                paymentType = formatText(
                    "transferSummary-step2PaymentByBeneficiary"
                );
                break;
        }

        let additionalCostsContent;
        if (immCostDetails.getIn(["total", "amount"]) > 0) {
            const plainAmountObject = getPlainAmountObject(
                immCostDetails.getIn(["type", "balance"])
            );
            const plainAmountSwiftObject = getPlainAmountObject(
                immCostDetails.get("swift")
            );

            additionalCostsContent = (
                <div>
                    <div className="transfer-step__costs-accordion-body-item">
                        <span className="transfer-step__costs-accordion-body-item-text">
                            {immCostDetails.getIn(["type", "title"]) ||
                                paymentType}
                        </span>
                        <OneLineSymbolAmount
                            className="pull-right"
                            amountObject={plainAmountObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(
                                plainAmountObject,
                                true
                            )}
                        />
                    </div>
                    <div className="transfer-step__costs-accordion-body-item">
                        <FormattedText value="transferSummary-step2SwiftCost" />
                        <OneLineSymbolAmount
                            className="pull-right"
                            amountObject={plainAmountSwiftObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(
                                plainAmountSwiftObject,
                                true
                            )}
                        />
                    </div>
                </div>
            );
        }

        return (
            <div className="transfer-step__costs">
                <Accordion isExpanded={true}>
                    <AccordionHeader name="AccordionHeader">
                        <div className="transfer-step__costs-accordion-header">
                            <FormattedText value="transferSummary-step2TotalCost" />
                            <OneLineSymbolAmount
                                className="pull-right"
                                amountObject={plainAmountTotalObject}
                                language={language}
                                amountObjectFormatted={formatAmountObject(
                                    plainAmountTotalObject,
                                    true
                                )}
                            />
                        </div>
                    </AccordionHeader>
                    <AccordionBody name="AccordionBody">
                        <div className="transfer-step__costs-accordion-body-item">
                            <FormattedText value="transferSummary-step2NominalCost" />
                            <OneLineSymbolAmount
                                className="pull-right"
                                amountObject={plainAmountNominalObject}
                                language={language}
                                amountObjectFormatted={formatAmountObject(
                                    plainAmountNominalObject,
                                    true
                                )}
                            />
                        </div>
                        { immBeneficiary.get("currency") !== EURO_TEXT && (
                        <React.Fragment>
                            <div className="transfer-step__costs-accordion-body-item">
                                <FormattedText value="transferSummary-step2CounterpartCost" />
                                <OneLineSymbolAmount
                                    className="pull-right"
                                    amountObject={plainAmountCounterObject}
                                    language={language}
                                    amountObjectFormatted={formatAmountObject(
                                    plainAmountCounterObject,
                                    true
                                )}
                            />
                            </div>
                            <div className="transfer-step__costs-accordion-body-item">
                                <FormattedText value="transferSummary-step2CurrencyCommisionCost" />
                                <OKTooltip
                                    content="transferSummary-step2CurrencyCommisionCostToolTip"
                                    offset={[0, -15]}
                            />
                                <OneLineSymbolAmount
                                    className="pull-right"
                                    amountObject={plainAmountCommisionObject}
                                    language={language}
                                    amountObjectFormatted={formatAmountObject(
                                    plainAmountCommisionObject,
                                    true
                                )}
                            />
                            </div>
                        </React.Fragment>
                        )}
                        {additionalCostsContent}
                        {incompleteInfoCommissionLine}
                        <div className="transfer-step__costs-accordion-body-item transfer-step__costs-accordion-body-item--subtitle">
                            <FormattedText value="transferSummary-step2LiquidToPay" />
                        </div>
                        <div className="transfer-step__costs-accordion-body-item">
                            <FormattedText value="transferSummary-step2OwnerCost" />
                            <OneLineSymbolAmount
                                className="pull-right"
                                amountObject={plainAmountOwnerObject}
                                language={language}
                                amountObjectFormatted={formatAmountObject(
                                    plainAmountOwnerObject,
                                    true
                                )}
                            />
                        </div>
                        <div className="transfer-step__costs-accordion-body-item">
                            <FormattedText value="transferSummary-step2BeneficiaryPerceivedAmount" />
                            <OneLineSymbolAmount
                                className="pull-right"
                                amountObject={plainAmountBeneficiaryObject}
                                language={language}
                                amountObjectFormatted={formatAmountObject(
                                    plainAmountBeneficiaryObject,
                                    true
                                )}
                            />
                        </div>
                    </AccordionBody>
                </Accordion>
                <OKMessage type="important">
                    <FormattedText value="transferSummary-step2WarningMessageCost" />
                </OKMessage>
            </div>
        );
    }

    buildOTPQuery() {
        const { immTransferState, immBeneficiary, immAccounts } = this.props;
        const accountId = immTransferState.getIn(["steps", 0, "fromAccount"]);
        const isEditingScheduled = immTransferState.getIn([
            "steps",
            0,
            "isEditingScheduled"
        ]);
        const beneficiaryType = immTransferState.getIn([
            "steps",
            0,
            "beneficiary",
            "type"
        ]);

        const data = {
            amount: immTransferState.getIn(["steps", 0, "amount"]),
            currency: immBeneficiary.get("currency"),
            product: immAccounts.getIn([accountId, "newProduct"]),
            contract: immAccounts.getIn([accountId, "newContractNumber"]),
            iban: immAccounts.getIn([accountId, "iban"]),
            beneficiaryIban: immBeneficiary.get("iban"),
            beneficiaryAccountNumber: immBeneficiary.get("accountNumber"),
            isToday: immTransferState.getIn(["steps", 0, "isToday"]),
            periodicityEnabled: immTransferState.getIn([
                "steps",
                0,
                "periodicityEnabled"
            ]),
            doTransferImmediate: immTransferState.get("doTransferImmediate")
        };

        const sepaType = getSepaTypeTransfers(
            immBeneficiary.get("country"),
            immBeneficiary.get("currency"),
            immBeneficiary.get("iban")
        );
        const operationQuery = getParamsOTP(sepaType, data, isEditingScheduled);

        let operationType = operationQuery.type;
        let operationParams = operationQuery.params;
        let codigoType;
        let serviceCode;

        if (
            (beneficiaryType === BENEFICIARY_TYPE_NEW ||
                beneficiaryType === BENEFICIARY_TYPE_NGO) &&
            !immTransferState.getIn(["steps", 0, "isReusingTransfer"]) &&
            !isEditingScheduled &&
            (immBeneficiary.get("addBeneficiary") ||
                immBeneficiary.get("isEditingBeneficiaryExisting"))
        ) {
            const isInsideSepa = isSepa(
                immBeneficiary.get("country"),
                immBeneficiary.get("currency")
            );

            if (immBeneficiary.get("isEditingBeneficiaryExisting")) {
                serviceCode = isInsideSepa
                    ? EDIT_SEPA_BENEFICIARY_ID
                    : EDIT_NO_SEPA_BENEFICIARY_ID;
                codigoType = CODIGO_MESSAGE_5;
            } else if (immBeneficiary.get("addBeneficiary")) {
                serviceCode = isInsideSepa
                    ? ADD_SEPA_BENEFICIARY_ID
                    : ADD_NO_SEPA_BENEFICIARY_ID;
                codigoType = CODIGO_MESSAGE_4;
            }

            operationType = MULTIPLE_OPERATIONS;
            operationParams = {
                id: codigoType,
                requestMulti: [
                    Object.assign(
                        { serviceCode: operationQuery.type },
                        operationQuery.params
                    ),
                    {
                        serviceCode: serviceCode,
                        ammount: 1,
                        currency: immBeneficiary.get("currency"),
                        destinationAccount:
                            immBeneficiary.get("iban") ||
                            immBeneficiary.get("accountNumber"),
                        optional1: immBeneficiary.get("alias")
                    }
                ]
            };
        }

        return (
            <SignaturePattern
                operationType={operationType}
                operationParams={operationParams}
            />
        );
    }

    buildOriginAccountBlock() {
        const fromAccountId = this.props.immTransferState
            .get("steps")
            .get(0)
            .get("fromAccount");
        const originAccount = !!fromAccountId
            ? this.props.immAccounts.get(fromAccountId)
            : null;
        if (originAccount) {
            const originAccountAlias =
                originAccount.get("alias") ||
                toCamelCase(originAccount.get("accountType"));

            return (
                <OKInformativeListItem
                    title={formatText("transferSummary-step2Origin")}
                    bodyText={originAccountAlias}
                >
                    <FormattedText
                        value="transferSummary-step1BeneficiaryIban"
                        className="transfer-step__iban-label"
                    />
                    <FormattedIban
                        className="transfer-step__iban-data"
                        key="txt_TransferStep2_BeneficiaryIban"
                        id="txt_TransferStep2_BeneficiaryIban"
                        iban={originAccount.get("iban")}
                    />
                </OKInformativeListItem>
            );
        }
    }

    buildPeriodicityLimit() {
        const firstStep = this.props.immTransferState.get("steps").get(0);
        let text;

        if (firstStep.get("periodicityEnabled")) {
            const periodicityType = firstStep.get("periodicityType");

            switch (periodicityType) {
                case constants.PERIODICITY_COUNT:
                    const count = firstStep.get("periodicityCount");
                    const translationText =
                        count === 1
                            ? "step2InfoMsgRepetitionsCountSingular"
                            : "step2InfoMsgRepetitionsCount";
                    text = formatText(`transferSummary-${translationText}`, [
                        count
                    ]);
                    break;
                case constants.PERIODICITY_DATE:
                    const dateHumanReadable = dateHelper.buildFormattedDate(
                        firstStep.get("periodicityDate"),
                        constants.DATE_FORMAT_ES
                    );
                    text = formatText("transferSummary-step2RepeatUntil", [
                        dateHumanReadable
                    ]);
                    break;
                case constants.PERIODICITY_CONSTANTLY:
                    text = formatText("periodicity-constantly");
                    break;
            }
        }

        return text ? <p> {text} </p> : false;
    }

    buildPeriodicityNonWorkableDay() {
        const firstStep = this.props.immTransferState.get("steps").get(0);
        let text;

        if (firstStep.get("periodicityEnabled")) {
            const periodicityTreatmentNonWorkableDay = firstStep.get(
                "periodicityTreatmentNonWorkableDay"
            );

            if (
                periodicityTreatmentNonWorkableDay ===
                constants.TRANSFER_EMITTED_DAY_BEFORE
            ) {
                text = formatText("transferSummary-step2EmittedDayBefore");
            } else if (
                periodicityTreatmentNonWorkableDay ===
                constants.TRANSFER_EMITTED_DAY_AFTER
            ) {
                text = formatText("transferSummary-step2EmittedDayAfter");
            }
        }

        return text ? <p>{text}</p> : false;
    }

    buildPeriodicityText() {
        const firstStep = this.props.immTransferState.get("steps").get(0);
        const periodicityRange = firstStep.get("periodicityRange");
        const rangeType = periodicityRange.toLowerCase();
        return __CONTACT_CENTER__ && periodicityRange === CC_PERIODICITY_CUSTOM
            ? buildCustomPeriodicityText(firstStep)
            : formatText(`periodicity-${rangeType}`);
    }

    buildTransferType() {
        if (!__CONTACT_CENTER__) return null;

        const { isTransferTypeChangeEnabled, immTransferState } = this.props;
        if (!isTransferTypeChangeEnabled()) return null;

        const immFirstStep = immTransferState.getIn(["steps", FIRST_STEP]);
        const transferType =
            immFirstStep.get("transferType") === CC_TRANSFER_TYPE_PAYROLL
                ? formatText("transferSummary-step2TransferTypePayroll")
                : formatText("transferSummary-step2TransferTypeOrdinary");

        return (
            <OKInformativeListItem
                title="transferSummary-step2TransferTypesTitle"
                bodyText={transferType}
            />
        );
    }

    buildTransferSummary() {
        const {
            immTransferState,
            immBeneficiary,
            transferPayerName,
            immAccounts
        } = this.props;
        const firstStep = immTransferState.get("steps").get(0);
        const transferConcept =
            firstStep.get("concept") || constants.EMPTY_CONCEPT;
        const periodicityEnabled = firstStep.get("periodicityEnabled");
        const isImmediateTransfer = immTransferState.get("doTransferImmediate");
        const currencySymbol = formatCurrency(
            immTransferState.getIn(["steps", 0, "fromAccountCurrency"])
        );

        const hasRepetitions = periodicityEnabled
            ? this.buildPeriodicityText()
            : formatText("transferSummary-step2NoRepetitions");
        const periodicityLimit = this.buildPeriodicityLimit();
        const periodicityNonWorkableDay = this.buildPeriodicityNonWorkableDay();

        let transfersCostType;
        let transferCostBlock;

        if (!!immTransferState.getIn(["extra", "costs"])) {
            if (!this.shouldWarnAboutCosts()) {
                transferCostBlock = this.buildCostAdditionalInfo();
            }

            let paymentType;
            switch (firstStep.get("costs")) {
                case constants.TRANSFER_COSTS_SENDER:
                    paymentType = formatText(
                        "transferSummary-step2PaymentByIssuer"
                    );
                    break;
                case constants.TRANSFER_COSTS_SHARED:
                    paymentType = formatText(
                        "transferSummary-step2PaymentByShared"
                    );
                    break;
                case constants.TRANSFER_COSTS_BENEFICIARY:
                    paymentType = formatText(
                        "transferSummary-step2PaymentByBeneficiary"
                    );
                    break;
            }

            transfersCostType = (
                <OKInformativeListItem
                    title="transferSummary-step2TransferCost"
                    bodyText={paymentType}
                />
            );
        }

        const transferAmount = {
            amount: firstStep.get("amount"),
            currency: immBeneficiary.get("currency")
        };
        const transferDate = dateHelper.buildFormattedDate(
            firstStep.get("date"),
            constants.DATE_FORMAT_ES
        );

        const originAccount = this.buildOriginAccountBlock();
        const beneficiaryBlock = this.buildBeneficiaryBlock(immBeneficiary);

        let beneficiaryName = toCamelCase(immBeneficiary.get("name"));

        const immAccount = immAccounts.get(firstStep.get("fromAccount"));
        const interventionType = formatText(
            `interventionTypes-${immAccount.get("interventionType")}`
        );
        const transferPayer = `${transferPayerName} (${interventionType})`;
        const emitter = firstStep.get("emitter");
        const transferEmitter = !!emitter
            ? this.buildTransferEmitter(emitter, immAccount)
            : transferPayer;
        const plainAmountObject = getPlainAmountObject(transferAmount);
        const transferType = this.buildTransferType();

        return (
            <section className="transfer-step__content-section">
                <section className="transfer-step__info">
                    <OKInformativeList columns={2}>
                        {originAccount}
                        {this.buildListItem(
                            "transferSummary-step2Amount",
                            undefined,
                            true,
                            this.buildOneSignSymbolItem(
                                plainAmountObject,
                                language
                            )
                        )}

                        {this.buildListItem(
                            "transferSummary-step2TransferEmitter",
                            transferPayer,
                            false
                        )}

                        {transferType}

                        {this.buildListItem(
                            "transferSummary-step2Beneficiary",
                            beneficiaryName,
                            __CONTACT_CENTER__,
                            beneficiaryBlock
                        )}

                        {this.buildListItem(
                            "transferSummary-step2TransferPayer",
                            transferEmitter,
                            false
                        )}

                        {!isImmediateTransfer &&
                            this.buildListItem(
                                "transferSummary-step2DateOfIssue",
                                transferDate
                            )}

                        {this.buildListItem(
                            "transferSummary-step2Concept",
                            transferConcept,
                            false
                        )}

                        {isImmediateTransfer
                            ? this.buildListItem(
                                "transferSummary-step2IsImmediate",
                                this.returnFormattedInmediateAmountForBody(
                                    immTransferState,
                                    currencySymbol
                                )
                            )
                            : this.buildListItem(
                                "transferSummary-step2Periodicity",
                                hasRepetitions,
                                true,
                                [periodicityLimit, periodicityNonWorkableDay]
                            )}
                        {transfersCostType}
                    </OKInformativeList>
                    {transferCostBlock}
                </section>
            </section>
        );
    }

    returnFormattedInmediateAmountForBody(immTransferState, currencySymbol) {
        return `${immTransferState.get("transferImmediateAmount") !== 0
            ? formatAmount(immTransferState.get("transferImmediateAmount"))
            : formatText("transferImmediate-free")
            } ${currencySymbol}`;
    }

    buildOneSignSymbolItem(plainAmountObject, language) {
        return (
            <OneLineSymbolAmount
                amountObject={plainAmountObject}
                className="transfer-step__amount"
                language={language}
                amountObjectFormatted={formatAmountObject(
                    plainAmountObject,
                    true
                )}
            />
        );
    }

    buildListItem(
        tittle,
        bodyText,
        bodyWordBreak = undefined,
        children = undefined
    ) {
        return (
            <OKInformativeListItem
                title={formatText(tittle)}
                bodyText={bodyText}
                bodyWordBreak={bodyWordBreak}
            >
                {children}
            </OKInformativeListItem>
        );
    }

    buildTransferEmitter(emitter, immAccount) {
        const code = parseInt(emitter.split(HYPHEN)[1]);
        const immInterveners = immAccount.getIn(["interveners", "list"]);
        const immSelectedIntervener = immInterveners.find(immIntervener => {
            return immIntervener.getIn(["identification", "code"]) === code;
        });

        return immSelectedIntervener
            ? `${immSelectedIntervener.get(
                "name"
            )} (${immSelectedIntervener.get("type")})`
            : "";
    }

    buildWarningMessage(url) {
        let content;
        if (this.shouldWarnAboutCosts()) {
            const { immGlobalVariables } = this.props;
            const title = formatText(
                "transferSummary-step2WarningMessageTitle"
            );
            const firstPart = formatText(
                "transferSummary-validationWarningMessageFirst"
            );
            const secondPart = formatText(
                "transferSummary-validationWarningMessageSecond"
            );
            const linkContent = this.buildLinkContent(url);
            const injectedStrings = [
                immGlobalVariables.getIn([
                    "variables",
                    "parameters",
                    "telefono",
                    "cliente"
                ])
            ];

            content = (
                <OKMessage title={title} type="important">
                    <p>{firstPart}</p>
                    <p>{secondPart}</p>
                    <p>
                        <FormattedText
                            value="transferSummary-validationWarningMessageThird"
                            injectedStrings={injectedStrings}
                        />
                    </p>
                    {linkContent}
                </OKMessage>
            );
        }

        return content;
    }

    buildLinkContent = url => {
        const { originCountry } = this.props;
        const showLink = originCountry !== PT;
        let content = null;

        if (showLink) {
            content = (
                <OKLink modifier="emphasize" to={url} target="_blank">
                    <FormattedText value="transferSummary-validationWarningMessageLink" />
                </OKLink>
            );
        }

        return content;
    };

    handleChangeDeduct = () => {
        const { showOTP } = this.state;

        if (
            this.props.immTransferState.getIn([
                "steps",
                0,
                "beneficiary",
                "notDeductibleNGOMessage"
            ]) &&
            showOTP
        ) {
            this.props.setWithValidateButton(showOTP);
        }

        this.setState({
            showOTP: !showOTP
        });
    };

    render() {
        const {
            immTransferState,
            immBeneficiary,
            immGlobalVariables,
            operative,
            immPayeeVerification,
        } = this.props;
        const { showOTP } = this.state;
        const transferSummary = this.buildTransferSummary();
        const warningMessageContent = this.buildWarningMessage(
            immGlobalVariables.getIn([
                "variables",
                "parameters",
                "contratos",
                "transferencias_extranjeras"
            ])
        );
        const otpContent = this.buildOTPQuery();
        const isEditingScheduled = immTransferState.getIn([
            "steps",
            0,
            "isEditingScheduled"
        ]);
        const oper =
            operative || isEditingScheduled
                ? formatText("operatives-transferDefaultEdit")
                : formatText("operatives-transferDefault");
        const messageNGO = buildNotDeductMessageNGO(
            immBeneficiary.get("name"),
            true,
            immTransferState.getIn([
                "steps",
                0,
                "beneficiary",
                "notDeductibleNGOMessage"
            ]),
            showOTP,
            this.handleChangeDeduct
        );
        const subtitleKey = isEditingScheduled
            ? "transferSummary-step2EditSummarySubtitle"
            : "transferSummary-step2SummarySubtitle";
        let showCheckDeduct = messageNGO === true ? true : showOTP;
        const confirmationSubTitleClassName = contactCenterClassName(
            "print-label",
            "transfer-step__subtitle"
        );
        const confirmationTitleClassName = contactCenterClassName(
            "print-title",
            "transfer-step__title"
        );

        return (
            <div
                className="transfer-step transfer-step--two"
                id="printable-wizard"
            >
                <h5 className={confirmationTitleClassName}>
                    <FormattedText
                        id="lbl_TransferStep2_Header"
                        value="transferSummary-step2SummaryTitle"
                    />
                </h5>

                <ContactCenterRender>
                    <ConfirmationScript
                        operative={oper}
                        confirmationType={CONFIRMATION_SCRIPT_GREETING}
                    />
                </ContactCenterRender>

                <div className={confirmationSubTitleClassName}>
                    <FormattedText
                        id="lbl_TransferStep2_Subtitle"
                        value={subtitleKey}
                    />
                </div>

                <article className="transfer-step__summary-content">
                    {transferSummary}
                </article>

                {warningMessageContent}

                {
                    immPayeeVerification.get('showInConfirmationScreen') && immPayeeVerification.get('partyNameMatch') && (
                        <div className="transfer-step__payee-verification-message">
                            <OKMessage type={MESSAGE_TYPE_IMPORTANT} title={formatText(getConfirmationScreenMessageTitleKey(immPayeeVerification.get('partyNameMatch')))}>
                                <HTMLSafeInjector
                                    message={formatTextNamed(getConfirmationMessageContentKey(immPayeeVerification.get('partyNameMatch')), { matchedName: immPayeeVerification.get('matchedName') } )}
                                />
                            </OKMessage>
                        </div>
                    )
                }

                <ContactCenterRender>
                    <ConfirmationScript
                        confirmationType={CONFIRMATION_SCRIPT_AGREEMENT}
                    />
                </ContactCenterRender>
                {messageNGO}
                <article className="transfer-step__signature-content">
                    {showCheckDeduct && otpContent}
                </article>
            </div>
        );
    }
}

TransferStep2.propTypes = {
    immTransferState: PropTypes.object,
    immAccounts: PropTypes.object,
    immBankEntity: PropTypes.object,
    immBeneficiary: PropTypes.object,
    immGlobalVariables: PropTypes.object,
    paymentByChanged: PropTypes.func,
    setEmailNotification: PropTypes.func,
    operative: PropTypes.object,
    transferPayerName: PropTypes.string,
    setWithValidateButton: PropTypes.func,
    isTransferTypeChangeEnabled: PropTypes.func,
    originCountry: PropTypes.string
};

module.exports.constructor = TransferStep2;
module.exports.TransferStep2 = connect(
    state => ({
        immGlobalVariables: state.globalVariables,
        originCountry: state.profile.get("originCountry"),
        immPayeeVerification: state.transfer.getIn(['steps', FIRST_STEP, 'payeeVerification']),
    }),
    {
        paymentByChanged: transferActions.paymentByChanged,
        setEmailNotification: transferActions.setEmailNotification,
        setWithValidateButton: signaturePatternActions.setWithValidateButton
    }
)(TransferStep2);
